import styled from "@emotion/styled";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useCotizacionStore } from "../../Services/Providers/CotizacionStore";
import { useDescripcionesStore } from "../../Services/Providers/DescripcionesStore";
import { useConfiguracionEmpresa } from "../../Services/Providers/useConfiguracionEmpresa";
import { TelefonosCompañia, telefonos } from "../../Assets/telefonosCompanias";
import { SegHeaderLogo } from "../../Components/SegUI/SegHeaderLogo/SegHeaderLogo";
import segurarse from "../../Assets/img/logo_segurarse.svg";
import { SegStepper } from "../../Components/SegUI/SegStepper/SegStepper";
import useSEOConfig from "../../hooks/seo/useSEOConfig";
import { obtenerParametros, obtenerDescripciones } from "../../Services/API/bff/auto";
import { CookiesComponent } from "../../Components/otros/CookiesComponent";
import { useConfig } from "../../context/ConfigContext";
import { buscarTextoSeo } from "../../utils/buscarTextoSeo";
import { SeoContenido } from "./SeoContenido";
import { debeMostrarBloqueSeo } from "../../utils/debeMostrarBloqueSeo";
import { VehiculoCotizacion } from "../../Components/Slides/Comunes/Cotizacion/VehiculoCotizacion";
import { DatosCotizacion } from "../../Components/Slides/Comunes/Cotizacion/DatosCotizacion";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* min-height: 100vh; */
`;

const Loading = styled.section`
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    background: #fff;
`;

export interface IPasos {
    step: number;
    subStep: number;
}

export interface CotizadorProps {
    step?: number;
    subStep?: number;
    esHome?: boolean;
}


export const Cotizador = ({ step = 0, subStep = 1, esHome = false }: CotizadorProps) => {

    const { compania } = useParams();
    const {config: envConf} = useConfig()
    const textoSeo = buscarTextoSeo("/cotizador-de-seguros-moto", envConf.pais);
    const nav = useNavigate();

    const Icon = styled.svg`
    color: #343434 !important;
  `;
    const referer = document.referrer;
    const landingUrl = document.location.href;

    const [steps, setSteps] = useState<IPasos>({ step, subStep });
    const { cotizacionValues, setCotizacionValues } = useCotizacionStore();
    const {
        descripcionesValues,
        setDescripcionesValues,
    } = useDescripcionesStore();

    const [paramsCargando, setParamsCargando] = useState(false);
    const { origen, config, setConfig } = useConfiguracionEmpresa();
    const mostrarSeo = debeMostrarBloqueSeo({ esHome, pais: envConf.pais, origen });
    const [phones, setPhones] = useState<TelefonosCompañia[]>(telefonos);
    const [justifyContent, setJustifyContent] = useState(
        "justify-content-center"
    );


    useSEOConfig({
        title: textoSeo?.title ?? "Moto",
        description: textoSeo?.description,
        tituloCompleto: !!textoSeo,
        marcaBlanca: (origen !== "SEGURARSE") ? config.origen.charAt(0).toUpperCase() +
            origen.slice(1).toLowerCase() : undefined,
        robots: (origen !== "SEGURARSE") ? "noindex, nofollow" : ""
    })


    useEffect(() => {
        function ajustarJustifyContent() {
            if (window.innerWidth >= 768) {
                setJustifyContent("col-md-3 text-md-end align-self-center");
            } else {
                setJustifyContent(
                    "d-flex align-items-center justify-content-center mt-3"
                );
            }
        }

        // Llamar a la función al cargar la página y al cambiar el tamaño de la ventana
        ajustarJustifyContent();
        window.addEventListener("resize", ajustarJustifyContent);

        // Limpieza del listener cuando el componente se desmonta
        return () => {
            window.removeEventListener("resize", ajustarJustifyContent);
        };
    }, []);



    useEffect(() => {
        setSteps((prev) => {
            return {
                ...prev,
                step: step,
                subStep: subStep,
            };
        });
    }, [step, subStep]);

    useEffect(() => {
        //if (!cotizacionValues.parametrosIniciales || cotizacionValues.parametrosIniciales.rubro !== "MOTO") {
        setParamsCargando(true);
        const fetchDataParams = async () => {
            const response: any = await obtenerParametros({ rubro: "Moto" });
            const origen = response.data.origen.includes("SEGURARSE") ? "SEGURARSE" : response.data.origen
            if (response) {
                // Cambio de rubro (p. ej. se venía cotizando un auto): el vehículo
                // guardado no sirve para moto, se limpia para no arrastrarlo.
                const rubroAnterior = cotizacionValues?.parametrosIniciales?.rubro;
                const cambioDeRubro = !!rubroAnterior && rubroAnterior !== "MOTO";
                setCotizacionValues({
                    ...cotizacionValues,
                    ...(cambioDeRubro && {
                        marca: undefined,
                        modelo: undefined,
                        version: undefined,
                        año: undefined,
                        esAntiguo: undefined,
                        patente: undefined,
                    }),
                    parametrosIniciales: response.data,
                    referer: referer,
                    landingUrl: landingUrl,
                });
                const estilos = response.data.estilos;
                if (estilos) {
                    setConfig({
                        ...JSON.parse(estilos),
                        origen
                    }, origen)
                } else {
                    setConfig({
                        origen,
                        images: {
                            logo: "",
                        },
                        colors: {
                            accent: "",
                            primary: "",
                            secondary: "",
                            tertiary: "",
                            icons: "",
                            navbar: "",
                            segu_stepper: ""
                        },
                        config: {
                            cookies: true
                        }
                    }, origen)
                }
            }
        };

        fetchDataParams().then(() => {
            setParamsCargando(false);
        });
        //}
    }, []);

    useEffect(() => {
        if (origen !== "SEGURARSE") {
            const favicon: any = document.querySelector('link[rel="icon"]');
            if (favicon) {
                favicon.href = config.images.favicon
            } else {
                const link = document.createElement('link');
                link.rel = 'icon';
                link.href = config.images.favicon || "";
                document.head.appendChild(link);
            }
        }
    }, [origen])

    useEffect(() => {
        if (
            cotizacionValues.parametrosIniciales &&
            descripcionesValues?.length === 0
        ) {
            const fetchDataDesc = async (
                rubro: string,
                origen: string,
                tipoCotizador: string
            ) => {
                const response: any = await obtenerDescripciones(
                    rubro,
                    origen,
                    tipoCotizador
                );
                if (response) {
                    setDescripcionesValues(response.data.api_data);
                }
            };
            fetchDataDesc(
                //cotizacionValues.parametrosIniciales.rubro,
                "moto",
                cotizacionValues.parametrosIniciales.origen,
                cotizacionValues.parametrosIniciales.tipoCotizador
            );
        }
    }, [cotizacionValues.parametrosIniciales]);

    useEffect(() => {
        if (cotizacionValues.contactoId) {
            setCotizacionValues({
                ...cotizacionValues,
                contactoId: undefined,
            });
        }
    }, [
        cotizacionValues.patente,
        cotizacionValues.marca,
        cotizacionValues.modelo,
        cotizacionValues.año,
        cotizacionValues.version,
        cotizacionValues.nombre,
        cotizacionValues.apellido,
        cotizacionValues.email,
        cotizacionValues.telefono,
        cotizacionValues.fechaNac,
        cotizacionValues.genero,
        cotizacionValues.localidad,
        cotizacionValues.provincia,
    ]);


    const tel = phones.filter((t: TelefonosCompañia) => {
        if (t.clave === compania) {
            return t;
        }
    });


    /**
     * Dos pasos: la moto (marca, modelo, año y versión juntos) y después todo
     * lo que falta en una sola pantalla. Moto no tiene paso de patente, así que
     * el primero es el vehículo. Las URLs de los slides viejos redirigen acá
     * (ver ArgRouter / UYRouter).
     */
    const renderVista = () => {
        switch (steps?.step) {
            case 0:
                return <VehiculoCotizacion rubro="moto" config={config} />;
            case 1:
                return (
                    <DatosCotizacion
                        rubro="moto"
                        config={config}
                        incluirVehiculo={false}
                    />
                );
            default:
                return <h1>loading</h1>;
        }
    };

    if (paramsCargando) {
        return (
            <Loading>
                <div className='d-flex flex-column justify-content-center align-items-center h-100'>
                    <p className=''><strong>Cargando</strong></p>
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </Loading>
        )
    }


    return (
        <>
            <PageContainer>
                <div className="sticky-top"
                    style={{ background: origen !== "SEGURARSE" ? config.colors.navbar : "#ffffff" }}
                >
                    <div className="container pt-3 pb-3">
                        {
                            config.origen !== "SEGURARSE" ?
                                <div className="row">
                                    <div className="col-md-6 offset-md-3 text-center d-flex justify-content-center gap-3">
                                        {" "}
                                        {/* Centra el contenido en la columna */}
                                        <SegHeaderLogo
                                            img={config.images.logo}
                                            alt="Logo Segurarse"
                                            width={window.innerWidth > 768 ? "130px" : "100px"}
                                            style={{ filter: "brightness(0) invert(1)" }}
                                        />
                                        <div style={{ height: "100%", width: "2px", backgroundColor: "#ffffff" }}></div>
                                        <SegHeaderLogo
                                            img={segurarse}
                                            alt="Logo Segurarse"
                                            width={window.innerWidth > 768 ? "140px" : "110px"}
                                            style={{ filter: "brightness(0) invert(1)" }}
                                        />
                                    </div>

                                </div>
                                :
                                <div className="row">
                                    <div className="col-md-6 offset-md-3 text-center">
                                        {" "}
                                        {/* Centra el contenido en la columna */}
                                        <SegHeaderLogo
                                            img={segurarse}
                                            alt="Logo Segurarse"
                                            width="160px"
                                        />
                                    </div>
                                    {compania && tel.length > 0 && (
                                        <div className={`${justifyContent}`}>
                                            {" "}
                                            {/* Alinea el contenido al centro vertical y a la derecha */}
                                            <a
                                                href={"tel:" + tel[0]?.telefono}
                                                className="tel align-items-center gap-2"
                                            >
                                                <Icon className="icon">
                                                    <use xlinkHref="#tel" />
                                                </Icon>
                                                {tel[0]?.telefono}
                                            </a>
                                        </div>
                                    )}
                                </div>
                        }
                    </div>
                </div>

                <div>
                    <SegStepper
                        icon="moto"
                        label="Cotizá tu moto online y encontrá el mejor precio"
                        stepActive={steps.step === 0 ? 1 : 2}
                        isStepper={true}
                        finalStep='$'
                        bgColor={origen !== "SEGURARSE" ? config.colors.segu_stepper : undefined}
                        iconColor={origen !== "SEGURARSE" ? config.colors.icons : undefined}
                        lineColor={origen !== "SEGURARSE" ? config.colors.icons : undefined}
                        labelColor={origen !== "SEGURARSE" ? config.colors.icons : undefined}
                        stepInactiveBgColor={origen !== "SEGURARSE" ? config.colors.icons : undefined}
                        stepActiveBorderColor={origen !== "SEGURARSE" ? config.colors.icons : undefined}
                        stepActiveTextColor={origen !== "SEGURARSE" ? config.colors.icons : undefined}
                    />
                </div>
                {paramsCargando ? (
                    <div className="d-flex justify-content-center py-5">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <>
                        {renderVista()}
                        <SeoContenido visible={mostrarSeo} />
                    </>
                )}

                {
                    config.config.cookies &&
                    <CookiesComponent />
                }
            </PageContainer>
        </>
    )
}